export default function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#0F0F0F] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-14">
          {/* Brand */}
          <div className="md:col-span-2">
            <img
              src="https://public.readdy.ai/ai/img_res/3b56ed0c-67be-43a8-9496-81a0323c110e.png"
              alt="FlexForce"
              className="h-10 w-auto object-contain mb-4 cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            />
            <p className="text-white/50 text-sm leading-relaxed max-w-xs mb-6">
              L&apos;externalisation commerciale nouvelle génération pour les TPE, PME et startups françaises.
              Flexible, rapide, et 100% orienté résultats.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/10 text-white/50 hover:text-[#6ECFA0] hover:border-[#6ECFA0]/50 transition-all duration-200 cursor-pointer"
                rel="nofollow"
              >
                <i className="ri-linkedin-fill text-sm" />
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/10 text-white/50 hover:text-[#6ECFA0] hover:border-[#6ECFA0]/50 transition-all duration-200 cursor-pointer"
                rel="nofollow"
              >
                <i className="ri-twitter-x-line text-sm" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <p className="text-[#6ECFA0] text-xs font-bold uppercase tracking-widest mb-5">Navigation</p>
            <ul className="space-y-3">
              {[
                { label: 'Notre offre', id: 'solution' },
                { label: 'Avantages', id: 'avantages' },
                { label: 'Processus', id: 'processus' },
                { label: 'Témoignages', id: 'temoignages' },
                { label: 'Devis gratuit', id: 'cta-final' },
              ].map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => scrollTo(link.id)}
                    className="text-white/50 hover:text-white text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="text-[#6ECFA0] text-xs font-bold uppercase tracking-widest mb-5">Contact</p>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-white/50 text-sm">
                <i className="ri-mail-line text-[#6ECFA0]" />
                contact@sellsyourbrand.com
              </li>
              <li className="flex items-center gap-2 text-white/50 text-sm">
                <i className="ri-phone-line text-[#6ECFA0]" />
                06 37 63 95 57
              </li>
              <li className="flex items-start gap-2 text-white/50 text-sm">
                <i className="ri-map-pin-line text-[#6ECFA0] mt-0.5" />
                <span>12 bd de l'atelier<br />66240 Saint-Estève</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/5 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs">
            &copy; {currentYear} SYB — Tous droits réservés
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-white/30 hover:text-white/60 text-xs transition-colors cursor-pointer" rel="nofollow">
              Mentions légales
            </a>
            <a href="#" className="text-white/30 hover:text-white/60 text-xs transition-colors cursor-pointer" rel="nofollow">
              Politique de confidentialité
            </a>
            <a href="#" className="text-white/30 hover:text-white/60 text-xs transition-colors cursor-pointer" rel="nofollow">
              CGV
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
